var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var styles = {
  root: {
    backgroundColor: "background",
    color: "text",
    fontFamily: "body",
    fontSize: 2,
    lineHeight: "body",
    margin: 0,
    padding: 0
  },
  h1: {
    variant: "textStyles.heading",
    fontSize: 5
  },
  h2: {
    variant: "textStyles.heading",
    fontSize: 4
  },
  h3: {
    variant: "textStyles.heading",
    fontSize: 3
  },
  h4: {
    variant: "textStyles.heading",
    fontSize: 2
  },
  h5: {
    variant: "textStyles.heading",
    fontSize: 1
  },
  h6: {
    variant: "textStyles.heading",
    fontSize: 0
  },
  a: {
    color: "text",
    textDecoration: "none",
    "&:hover, &:focus": {
      textDecoration: "underline"
    }
  },
  p: {
    margin: 0,
    marginBottom: 3,
    "&:last-of-type": {
      marginBottom: 0
    }
  }
}; // Adding those two very browser specific css rules that way to avoid poluting the theme object with ts-ignores

styles.root = __assign(__assign({}, styles.root), {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore-next-line
  MozOsxFontSmoothing: "grayscale",
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore-next-line
  WebkitFontSmoothing: "antialiased"
});
export default styles;